import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';

import Box from '@mui/material/Box';

import { LoginInput } from '@ts-core/modules/auth/types/Auth';
import LoginForm from '@ts-core/modules/auth/components/LoginForm';
import ConfirmationDialog, { useConfirmDialog } from '@ts-core/core/components/ConfirmDialog';

import { useStudentAuth } from 'modules/account/hooks';

const LoginPage = () => {
  const intl = useIntl();
  const { onSignIn, signInLoading, signInError, isAuthenticated, onGetActiveSession, getActiveSessionLoading } = useStudentAuth();
  const { dialogProps, onOpenDialog } = useConfirmDialog({
    onConfirm: (loginData?: LoginInput) => {
      if (loginData) {
        onSignIn(loginData);
      }
    },
  });

  const handleSignIn = useCallback(
    (input: LoginInput) => {
      onGetActiveSession(input.email, (session) => {
        if (session) {
          onOpenDialog({
            message: intl.formatMessage({ id: 'session.existingSessionAlert.message' }),
            data: input,
            confirmActionTitle: intl.formatMessage({ id: 'button.continue' }),
          });
        } else {
          onSignIn(input);
        }
      });
    },
    [onSignIn, onGetActiveSession, onOpenDialog, intl]
  );

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }
  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box width={{ xs: '100%', md: 400 }} maxWidth={{ xs: 400, md: undefined }} p={2} my={3} mt={24}>
        <LoginForm
          title={intl.formatMessage({ id: 'loginStudent.title' })}
          onSubmit={handleSignIn}
          error={signInError}
          isSubmitting={signInLoading || getActiveSessionLoading}
          showResetPassword
          footerText={intl.formatMessage({ id: 'login.areYouProfessor' })}
          footerUrl="https://profesor.check.uy"
        />
      </Box>
      <ConfirmationDialog {...dialogProps} />
    </Box>
  );
};

export default LoginPage;
